import { ModalName } from '@/constants/modals';
import { useCompanyNeedStore } from '@/modules/companyNeed/store/companyNeedStore';

import type {
	ExistingInterview,
	ScheduleInterviewSuccessPayload,
	ScheduleInterviewType,
} from '@/components/modal/Profile/scheduleInterview/types';
import type { MoveWorker } from '@/modules/companyNeed/types/moveWorker';
import type { LabelValue } from '@/types/common';

import { useModalStore } from '@/dsComponents/modals/modalStore';

export type OpenScheduleInterviewModalOptions =
	| {
			worker: MoveWorker;
			companyNeedId: string;
			mode: ScheduleInterviewType.AGENCY;
			companyId?: string;
			existingInterview?: ExistingInterview;
	  }
	| {
			worker: MoveWorker;
			companyNeedId: string;
			mode: ScheduleInterviewType.CLIENT;
			companyId: string;
			existingInterview?: ExistingInterview;
	  };

const buildPreloadedCompanyContacts = (): LabelValue<string>[] | undefined => {
	const companyNeedStore = useCompanyNeedStore();
	const contacts = companyNeedStore.companyContacts;
	if (!contacts.length) return undefined;

	return contacts.map((contact) => ({
		label:
			[contact.firstname, contact.lastname].filter(Boolean).join(' ').trim() ||
			'',
		value: String(contact.id ?? ''),
	}));
};

export const openScheduleInterviewModal = (
	options: OpenScheduleInterviewModalOptions,
	onSuccess?: (
		payload?: ScheduleInterviewSuccessPayload
	) => void | Promise<void>,
	onCancel?: () => void
) => {
	const { worker, companyNeedId, mode, existingInterview } = options;
	const companyId = 'companyId' in options ? options.companyId : undefined;
	if (!worker.id) return;

	const modalStore = useModalStore();

	modalStore.actions.open(ModalName.ProfileScheduleInterviewModal, {
		open: true,
		workerId: worker.id,
		companyNeedId,
		mode,
		workerFirstname: worker.firstname,
		workerLastname: worker.lastname,
		...(companyId && { companyId }),
		...(existingInterview && { existingInterview }),
		preloadedCompanyContacts: buildPreloadedCompanyContacts(),
		onSuccess,
		onCancel,
	});
};
